/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import TextField from "@mui/material/TextField";
import { Autocomplete } from "@mui/material";

import styles from "../InterviewPipeline.module.scss";

import {
  updateColumnFilter,
  clearColumnFilter,
  fetchPipeline,
} from "../../../../redux-store/slices/pipelineSlice";

import { AiOutlineClose } from "react-icons/ai";
import { decryptedAdminID } from "../../../../utility";
import { getAdminIds } from "../../../../services/candidateServices";
import { getpipelineReasonNames } from "../../../../services/interviewServices";
import { debounce } from "lodash";
import DateFilter from "../../../../components/Common/FilterComponent/DateFilter";

// ✅ CONSTANT
const ALL_OPTION = { id: "ALL", name: "All" };

const StateFilter = ({ stageId, stageName, existingFilters, onClose }) => {
  const dispatch = useDispatch();

  const adminDetails = useSelector((state) => state.adminDetails);
  const isSuperAdmin = adminDetails.roleID == 1;
  const isTeamLeader = localStorage.getItem("teamLeader") == "true"
  const [resetDateFilter, setResetDateFilter] = useState(false);

  const adminID = Number(decryptedAdminID());

  const [adminList, setAdminList] = useState([]);
  const [reasonList, setReasonList] = useState([]);

  // ✅ LOCAL FILTER STATE
  const today = new Date().toISOString().split("T")[0];

const [filters, setFilters] = useState({
  stage_id: stageId,
  sub_stage_id: null,
  mobile_number: null,
  first_name: null,
  company_name: null,
  date_from: stageId === 8 ? "2025-12-01" : null,
  date_to: stageId === 8 ? today : null,
  admin_ids: [],
});
  // ✅ LOAD EXISTING FILTERS (IMPORTANT)
  // useEffect(() => {
  //   if (existingFilters) {
  //     setFilters((prev) => ({
  //       ...prev,
  //       ...existingFilters,

  //       admin_ids:
  //         existingFilters?.admin_ids?.length > 0
  //           ? existingFilters.admin_ids
  //           : prev.admin_ids?.length > 0
  //             ? prev.admin_ids
  //             : adminList.length > 0
  //               ? adminList.map((a) => a.id)
  //               : [],
  //     }));
  //   }
  // }, [existingFilters, adminList]);

  useEffect(() => {
  if (existingFilters) {
    setFilters((prev) => ({
      ...prev,
      ...existingFilters,

      date_from:
        existingFilters?.date_from ??
        (stageId === 8 ? "2025-12-01" : null),

      date_to:
        existingFilters?.date_to ??
        (stageId === 8 ? today : null),

      admin_ids:
        existingFilters?.admin_ids?.length > 0
          ? existingFilters.admin_ids
          : prev.admin_ids?.length > 0
          ? prev.admin_ids
          : adminList.length > 0
          ? adminList.map((a) => a.id)
          : [],
    }));
  }
}, [existingFilters, adminList]);

  // ✅ FETCH ADMINS + HANDLE DEFAULT PROPERLY

  //   const debouncedFetchAdmins = useRef(
  //   debounce(async (adminID, existingFilters) => {
  //     try {
  //       const res = await getAdminIds({
  //         id: adminID,
  //         onlyMe: false,
  //       });

  //       const formatted = (res?.data || []).map((item) => ({
  //         id: item.admin_id,
  //         name: item.admin_id === adminID ? "Self" : item.user_name,
  //       }));

  //       setAdminList(formatted);

  //       setFilters((prev) => ({
  //         ...prev,
  //         admin_ids:
  //           existingFilters?.admin_ids?.length > 0
  //             ? existingFilters.admin_ids
  //             : formatted.map((a) => a.id),
  //       }));
  //     } catch (err) {
  //       console.log("Admin Fetch Error:", err);
  //     }
  //   }, 300)
  // ).current;

  const debouncedFetchAdmins = useRef(
    debounce(async (adminID, existingFilters) => {
      try {
        const res = await getAdminIds({
          id: adminID,
          onlyMe: false,
        });

        const formatted = (res?.data || []).map((item) => ({
          id: item.admin_id,
          name: item.admin_id === adminID ? "Self" : item.user_name,
        }));

        setAdminList(formatted);

        // ✅ IMPORTANT FIX
        setFilters((prev) => ({
          ...prev,
          admin_ids:
            existingFilters?.admin_ids?.length > 0
              ? existingFilters.admin_ids
              : prev.admin_ids?.length > 0
                ? prev.admin_ids
                : formatted.map((a) => a.id),
        }));
      } catch (err) {
        console.log("Admin Fetch Error:", err);
      }
    }, 300),
  ).current;
  useEffect(() => {
    debouncedFetchAdmins(adminID, existingFilters);

    return () => {
      debouncedFetchAdmins.cancel();
    };
  }, []);
  const debouncedFetchReasons = useRef(
    debounce(async (stageId, setReasonList) => {
      try {
        const data = await getpipelineReasonNames(stageId);

        const formatted = (data || []).map((item) => ({
          id: item.id,
          name: item.stage_name,
        }));

        setReasonList(formatted);
      } catch (err) {
        console.log("Reason Fetch Error:", err);
      }
    }, 300),
  ).current;
  useEffect(() => {
    if (stageId) {
      debouncedFetchReasons(stageId, setReasonList);
    }

    // cleanup (VERY IMPORTANT)
    return () => {
      debouncedFetchReasons.cancel();
    };
  }, [stageId]);

  // ✅ INPUT CHANGE
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value || null,
    }));
  };

  // ✅ ADMIN CHANGE
  const handleAdminChange = (event, value) => {
    if (!value) {
      setFilters((prev) => ({
        ...prev,
        admin_ids: [],
      }));
      return;
    }

    // ALL
    if (value.id === "ALL") {
      setFilters((prev) => ({
        ...prev,
        admin_ids: adminList.map((a) => a.id),
      }));
      return;
    }

    // SINGLE
    setFilters((prev) => ({
      ...prev,
      admin_ids: [value.id],
    }));
  };

  // ✅ SELECTED VALUE (UI SYNC FIX)
  const selectedValue = (() => {
    if (!filters.admin_ids?.length || !adminList.length) return null;

    // ALL
    if (filters.admin_ids.length === adminList.length) {
      return ALL_OPTION;
    }

    // SINGLE
    return adminList.find((a) => a.id === filters.admin_ids[0]) || null;
  })();

  const handleReasonChange = (event, value) => {
    setFilters((prev) => ({
      ...prev,
      sub_stage_id: value ? value.id : null,
    }));
  };
  const applyFilter = () => {
    // ✅ SAVE FILTER
    dispatch(
      updateColumnFilter({
        stageId,
        filters,
      }),
    );

    dispatch(
      fetchPipeline({
        stage_id: stageId,
        offset: 0,
      }),
    );

    onClose();
  };
  // ✅ CLEAR FILTER
  const handleClear = () => {
    dispatch(clearColumnFilter(stageId));

    const allIds = adminList.map((a) => a.id);

    const resetFilters = {
      stage_id: stageId,
      mobile_number: null,
      first_name: null,
      company_name: null,
      date_from: null,
      date_to: null,
      admin_ids: allIds,
    };

    setFilters(resetFilters);
    setResetDateFilter(true);

    dispatch(
      fetchPipeline({
        stage_id: stageId,
        offset: 0,
      }),
    );
  };
  const selectedReason =
    reasonList.find((r) => r.id === filters.sub_stage_id) || null;

  return (
    <div className={styles.StatefilterPanel}>
      {/* HEADER */}
      <div className={styles.filterHeader}>
        <b>{stageName} Filter</b>
        <button onClick={onClose} className={styles.ClearButton}>
          <AiOutlineClose />
        </button>
      </div>

      {/* BODY */}
      <div className={styles.filterBody}>
        <div className={styles.row}>
          {/* <TextField
            fullWidth
            label="Mobile Number"
            name="mobile_number"
            value={filters.mobile_number || ""}
            onChange={handleChange}
          /> */}

          <TextField
            fullWidth
            label="Mobile Number"
            name="mobile_number"
            value={filters.mobile_number || ""}
            onChange={(e) => {
              const value = e.target.value;

              // ✅ Allow only numbers & max 10 digits
              if (/^\d{0,10}$/.test(value)) {
                handleChange(e);
              }
            }}
            inputProps={{
              maxLength: 10,
              inputMode: "numeric", // mobile keyboard
              pattern: "[0-9]*"
            }}
          />

          <TextField
            fullWidth
            label="Candidate Name"
            name="first_name"
            value={filters.first_name || ""}
            onChange={handleChange}
          />
        </div>
        <div className={styles.row}>
          <div style={{ flex: 1 }}>
            <TextField
              fullWidth
              label="Company Name"
              name="company_name"
              value={filters.company_name || ""}
              onChange={handleChange}
            />
          </div>

          <div style={{ flex: 1 }}>
            <Autocomplete
              fullWidth
              options={reasonList}
              getOptionLabel={(option) => option.name || ""}
              value={selectedReason}
              onChange={handleReasonChange}
              isOptionEqualToValue={(opt, val) => opt.id === val.id}
              renderInput={(params) => (
                <TextField {...params} label="Reason / Sub Stage" fullWidth />
              )}
            />
          </div>
        </div>

        {/* DATE */}
        <div className="mt-1">
          <b>Moved Date :</b>
          {/* <div className={`mt-1 ${styles.row}`}>
            <TextField
              fullWidth
              type="date"
              name="date_from"
              value={filters.date_from || ""}
              InputLabelProps={{ shrink: true }}
              onChange={handleChange}
            />

            <TextField
              fullWidth
              type="date"
              name="date_to"
              value={filters.date_to || ""}
              InputLabelProps={{ shrink: true }}
              onChange={handleChange}
            />
          </div> */}
          <div className="mt-2 mb-2">
            <DateFilter
              resetTrigger={resetDateFilter}
              value={{
                date_from: filters.date_from,
                date_to: filters.date_to,
              }}
              onChange={(dates) => {
                setFilters((prev) => ({
                  ...prev,
                  date_from: dates.date_from || null,
                  date_to: dates.date_to || null,
                }));
              }}
            />
          </div>
        </div>

        {/* ADMIN FILTER */}
        {(isSuperAdmin || isTeamLeader) && (
          <Autocomplete
            options={[ALL_OPTION, ...adminList]}
            getOptionLabel={(option) => option.name || ""}
            value={selectedValue}
            onChange={handleAdminChange}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            renderInput={(params) => (
              <TextField {...params} label="Admin Name" />
            )}
          />
        )}
      </div>

      {/* FOOTER */}
      <div className={styles.filterFooter}>
        <button className={styles.ClearButton} onClick={handleClear}>
          Clear
        </button>

        <button className={styles.ApplyButton} onClick={applyFilter}>
          Apply Filter
        </button>
      </div>
    </div>
  );
};

export default StateFilter;
